export function convertToNumber(input: string | number): number {
  if (typeof input === 'number') {
    return input
  }

  if (input === '') {
    throw new Error(
      'Invalid input: empty string cannot be converted to a number'
    )
  }

  const convertedNumber = Number(input)

  if (Number.isNaN(convertedNumber)) {
    throw new Error(`Invalid input: ${input} cannot be converted to a number`)
  }

  return convertedNumber
}
